module.exports = "/packs/images/svg/ireland/facilities/event_conference_room~ea3172e80cdfd65b5ff53ce72d1f1de6.svg";